import {Component, OnInit} from '@angular/core';
import {MyDatePickerModule, IMyDpOptions} from 'mydatepicker';
import {CallBackEndService} from '../call-back-end.service';
import {IbRequest} from '../ib-request';
import {IbResponse} from '../ib-response';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import {Angular2CsvModule} from 'angular2-csv';
declare var getHexAscii: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as jsPDF from 'jspdf';
import 'rxjs/Rx';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-statment-of-account',
  templateUrl: './statment-of-account.component.html',
  styleUrls: ['./statment-of-account.component.css'],
  providers: [DatePipe]
})
export class StatmentOfAccountComponent implements OnInit {
  public filterQuery = '';
  public rowsOnPage = 5;
  public sortBy = 'particulars';
  public sortOrder = 'asc';

  isShow: string = 'page1';
  isShow1: string = 'page1';
  scoAccounts: any;
  scoAndLoanAccounts: any = [];
  loanAccounts: any = [];
  // statementOfAccountList : any = [];
  data: any = [];
  otherDetails: any = [];
  accountDigit: any;
  fromDate: any;
  toDate: any;
  fromDate1: any;
  toDate1: any;
  statacct: string="";
  address1: string;
  address2: string;
  totalDebit: any;
  totalCredit: any;
  totalAmount: any;
  pdfName: string;
  crOrDr: any;
  space = '  ';
  formatedDate : string='';
  loanStatementOfAccountResp: any = [];
  loanAccountHolderDetails: any = [];
  excelOrPdfName: string;
  scAccount: string;
  scAccounts: any = [];
  fromDateNull : string ='';
  toDateNull : string='';
  messageForDate : string = '';
  messageForDate1 : string = '';
  messageForDate2 : string = '';
  fromGreaterCurrent : string ='';
  accountNull : string = '';
  accountHolderName: string =sessionStorage.getItem('storedUserName');
  accountInfo: any;
  subBtnDisabled:boolean=false;
  error:string="";
  isError:boolean=false;
  mytime:Date = new Date();
  currentYear:any= this.mytime.getUTCFullYear();
  currentDate:any= this.mytime.getUTCDate()+1;
  currentMonth:any= this.mytime.getUTCMonth() + 1;
  currentMonth1:any= this.mytime.getUTCMonth() + 7;
  fromyear=this.mytime.getUTCFullYear()-5;
  indNum : number=0;
  hasExtraLine: boolean;
  constructor(private webService: CallBackEndService,
              private spinnerService: Ng4LoadingSpinnerService,private datePipe: DatePipe
  ) {
    this.scoAccounts = JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.scoAndLoanAccounts = JSON.parse(sessionStorage.getItem('scoAndLoanAccounts'));
    this.loanAccounts = JSON.parse(sessionStorage.getItem('loanAccounts'));
    console.log("loan account isss " + this.loanAccounts + "sc accounts iss " + this.scoAndLoanAccounts);
    this.scAccounts = JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.accountInfo = JSON.stringify(JSON.parse(sessionStorage.getItem('accountInfo')));
    console.log("sc accounts " + this.scAccounts + "account info " + this.accountInfo);
    this.scAccount = this.scAccounts[0];
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    request.param1 = getHexAscii('', this.scAccount);
    request.param2 = this.scAccount;
    this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
      if (data !== null && data.status === 'S200') {
        this.accountInfo = data.param5;
        //this.showLoanAmount ='Hide';
      }
    });
  }
  loanAccount1 = JSON.parse(sessionStorage.getItem('loanAccounts'));

  scoAndLoanAccount1 = JSON.parse(sessionStorage.getItem('scoAndLoanAccounts'));
  ngOnInit() {
   
    this.formatedDate = this.datePipe.transform(new Date(), 'dd-MMM-yyyy');
  }
  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
    editableDateField:false,
	//disableUntil:{year: this.fromyear, month: this.currentMonth, day: this.currentDate-2},
	 disableUntil:{year: this.fromyear, month: this.currentMonth, day: this.currentDate-2},
     disableSince:{year: this.currentYear, month: this.currentMonth, day: this.currentDate},
	
  };
  myDatePickerOptions1: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
    editableDateField:false,
    disableSince:{year: this.currentYear, month: this.currentMonth, day: this.currentDate},
  };
  ScAcctInfo() {
    //this.scAccount=this.scAccounts[0];
    console.log("call service ");
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    request.param1 = getHexAscii('', this.scAccount);
    request.param2 = this.scAccount;
    this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => { 
      if (data !== null && data.status === 'S200') {
        this.accountInfo = data.param5;
        console.log("changing data" + this.accountInfo);
        //this.showLoanAmount ='Hide';
      }
    });
  }
  dateconvert(monthNumber) { //1 = January
    var monthNames = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
      'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
    return monthNames[monthNumber - 1];
  }
  statementOfAccount() {
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    this.spinnerService.show();
    this.subBtnDisabled = true;
    this.accountNull = '';
    this.fromDateNull = '';
    this.toDateNull = '';
    //this.isLoad = true;
    if (this.statacct === '' || this.statacct === undefined || this.statacct === null) {
      this.accountNull = 'no';
      this.spinnerService.hide();
      this.subBtnDisabled = false;
    } else if (this.fromDate === '' || this.fromDate === undefined || this.fromDate === null) {
      this.fromDateNull = 'no';
      this.subBtnDisabled = false;
      this.spinnerService.hide();
    } else if (this.toDate === '' || this.toDate === undefined || this.toDate === null) {
      this.toDateNull = 'no';
      this.subBtnDisabled = false;
      this.spinnerService.hide();
    } else {

      this.messageForDate = '';
      this.messageForDate1 = '';
      this.messageForDate2 = '';
      this.fromGreaterCurrent = '';
      var date1 = (this.fromDate.date.day + "-" + this.dateconvert(this.fromDate.date.month) + "-" + this.fromDate.date.year).split("-");
      var date2 = (this.toDate.date.day + "-" + this.dateconvert(this.toDate.date.month) + "-" + this.toDate.date.year).split("-");
      var date3 = this.formatedDate.split("-");
      var d1 = Date.parse(date1[0] + "-" + date1[1] + "-" + date1[2]);
      var d2 = Date.parse(date2[0] + "-" + date2[1] + "-" + date2[2]);
	  var d3 = Date.parse(date3[0] + "-" + date3[1] + "-" + date3[2]);
	  console.log("d1---"+date1+" d2---"+date2+"d3---"+date3+"current date--"+this.formatedDate);
      if (d1 > d2) {
        this.messageForDate = 'no';
        this.subBtnDisabled = false;
        this.spinnerService.hide();
      } else if (d2 > d3) {
        this.messageForDate1 = 'no';
        this.subBtnDisabled = false;
        this.spinnerService.hide();
      } else if (d1 > d3) {
        this.fromGreaterCurrent = 'no';
        this.subBtnDisabled = false;
        this.spinnerService.hide();
      } else {
        this.accountDigit = this.scoAccounts[0];

        //const frm =JSON.stringify(this.fromDate1);
        // console.log("frm date "+this.fromDate.formatted+"");
        // console.log("frm year "+this.fromDate.date.year+"");
        // console.log("frm month "+this.fromDate.date.month+"");
        // console.log("frm day "+this.fromDate.date.day+"");

        request.param3 = this.fromDate.date.day + "-" + this.getMonthName(this.fromDate.date.month) + "-" + this.fromDate.date.year;
        request.param4 = this.toDate.date.day + "-" + this.getMonthName(this.toDate.date.month) + "-" + this.toDate.date.year;
        request.param5 =sessionStorage.getItem('storedUserName');

        request.param1 = getHexAscii('', this.statacct + request.param3 + request.param4+ request.param5);
        //request.param2=sessionStorage.getItem('storedUserName');
        //request.param2 = this.accountDigit;
        request.param2 = this.statacct;
        // request.param3=this.fromDate.formatted+"";
        //request.param4 =this.toDate.formatted+"";
        
        console.log("from date  " + this.fromDate + "to date  " + this.fromDate);
        this.webService.getResponse(request, 'accountStatement').subscribe((data: IbResponse) => {
          this.spinnerService.hide();
          response = data;

          if (response !== null && response.status === 'S200') {
            if(response.param6!=null && response.param6.length!=0 ){
            this.data = data.param6;
            this.otherDetails = data.param5;
            this.subBtnDisabled = false;
            this.isError = false;
            this.error = ' ';
            //   this.excelOrPdfName=this.otherDetails.accountNo15Digit+'_'+this.otherDetails.todayDate;
            if( this.otherDetails.add1!=null && this.otherDetails.add1!=undefined && this.otherDetails.add1!==''){
              this.address1 = this.otherDetails.add1 + ', ';
            }
            if( this.otherDetails.add2!=null && this.otherDetails.add2!=undefined && this.otherDetails.add2!==''){
              this.address1 =  this.address1 +this.otherDetails.add2 + ', ';
            }
            if( this.otherDetails.add3!=null && this.otherDetails.add3!=undefined && this.otherDetails.add3!==''){
              this.address1 = this.address1 + this.otherDetails.add3 + ', ';
            }
          
           // this.address1 = this.otherDetails.add1 + ', ' + this.otherDetails.add2 + ', ' + this.otherDetails.add3 + ', ' + this.otherDetails.phoneNo;
            this.address2 = this.otherDetails.areaDesc + ', ' + this.otherDetails.cityDesc + ', ' + this.otherDetails.pinCd;
            this.isShow1 = 'page2';
           // this.spinnerService.hide();
           // console.log("statment list isss " + this.data);
            for (const [key, value] of Object.entries(this.data)) {
              if (value.drCr === 'D') {
                this.totalDebit = this.totalDebit + Number(value.fcyTrnAmt || 0);
                this.crOrDr = 'DR';
              }
              if (value.drCr === 'C') {
                this.totalCredit = this.totalCredit + Number(value.fcyTrnAmt || 0);
                this.crOrDr = 'CR';
              }
              console.log('---------==     '+value.balance);
              this.totalAmount = value.balance;
            }
          }else{
            console.log('p6 null');
            this.isError = true;
            this.error ='Record Not Found';
            this.subBtnDisabled = false;
            this.isShow1 = '';
          }
            //this.error = response.statusDescription;
          } else {
          //  this.spinnerService.hide(); 
            this.isError = true;
            if (response.statusDescription!=null){
              this.error = response.statusDescription;
            }else  if (response.param1!=null){
              this.error = response.param1;
            }else{
              this.error = 'Something Went Wrong.Please Try Again Later';
            }
           
            this.subBtnDisabled = false;
            this.isShow1 = '';
            
          }
        });
      }
    }
  }


  // Final Code for Download CSV Function

  downloadPdf() {
    var pdf = new jsPDF();

    var a = Number(20 || 0);
    var b = Number(5 || 0);
    var c = Number(30 || 0);
    var d = Number(20 || 0);
    var e = Number(179 || 0);
    var f = Number(25 || 0);
    var g = Number(3 || 0);
    var i = Number(1 || 0);
    var totalDrAmount = Number(0 || 0);
    var totalCrAmount = Number(0 || 0);
    var totalClosingAmount = Number(0 || 0);
    var crDr = '';
    var pdfName = this.otherDetails.accountNo15Digit + '_' + this.otherDetails.todayDate;

    pdf.setFontSize(6);
    pdf.text(4, a, 'Branch  Name : '); pdf.text(25, a, this.otherDetails.branchName + ''); pdf.text(120, a, '15 Digit Account Id : '); pdf.text(145, a, this.otherDetails.accountNo15Digit + ''); a = a + b; d = d + b;
    pdf.text(4, a, 'Name : '); pdf.text(25, a, this.otherDetails.name + ''); pdf.text(120, a, 'Account Type : '); pdf.text(145, a, this.otherDetails.acctType + ''); a = a + b; d = d + b;
    pdf.text(4, a, 'Address : '); pdf.text(25, a, this.address1 + ''); a = a + g; d = d + g; //a = a + g; d = d + g;
    pdf.text(25, a, this.address2 + ''); a = a + b; d = d + b;
    pdf.text(4, a, 'Contact Number : '); pdf.text(25, a, this.otherDetails.phoneNo); a=a+g; d=d+g;                   
    pdf.text(4, a, 'Opening Balance As On ' + this.otherDetails.fromDate + ' : '); pdf.text(45, a, this.otherDetails.openingBalance + ''); a = a + b; d = d + b;
    // pdf.text(4, a, 'Opening Balance As On ' + this.otherDetails.fromDate + ' : '); pdf.text(45, a, this.otherDetails.openingBalance + ''); pdf.text(120, a, 'Current ROI% : '); pdf.text(135, a, this.otherDetails.intrest + ''); a = a + b; d = d + b;
    // pdf.text(4, a, 'Limit Effective Date  : '); pdf.text(25, a, this.otherDetails.limitEffDate + ''); pdf.text(120, a, 'Expiry Date : '); pdf.text(135, a, this.otherDetails.limitExpDate + ''); a = a + b; d = d + b;
    // pdf.text(4, a, 'Total Sanction Limit : '); pdf.text(25, a, this.otherDetails.totSacnctionLimit + ''); pdf.text(120, a, 'Expiry Date with Grace Period : '); pdf.text(155, a, this.otherDetails.expDateGrace + ''); a = a + b; d = d + b;
    pdf.text(4, a, 'Branch IFSC Code : '); pdf.text(25, a, this.otherDetails.branchIfscCd + ''); pdf.text(120, a, 'Branch MICR Code : '); pdf.text(145, a, this.otherDetails.micrCode + ''); a = a + b; d = d + b;
    pdf.text(4, a, 'Joint Holder 1 : '); pdf.text(25, a, this.otherDetails.firstJointHolder + ''); pdf.text(120, a, 'Joint Holder 2 : '); pdf.text(145, a, this.otherDetails.secondeJointHolder + ''); a = a + b; d = d + b;
    pdf.text(4, a, 'Account : '); pdf.text(25, a, this.otherDetails.accountWithName + ''); pdf.text(120, a, 'Period : '); pdf.text(135, a, this.otherDetails.period + ''); a = a + b; d = d + b;

    c = d + 5;
    pdf.line(2, a - 3, e, a - 3);
    for (const [key, value] of Object.entries(this.data)) {

      /*console.log("----------"+key + ": " + value.postDate + ": " + value.particulars + ": " + value.instrNo + ": " + value.fcyTrnAmt + ": " + value.balance);*/
      if (i === 1) {
        pdf.setFontType("bolditalic");
        pdf.setTextColor(0, 0, 255);

        pdf.text(2, a, 'SR. No.');
        pdf.text(10, a, 'Date');
        pdf.text(40, a, 'Particulars');
        pdf.text(110, a, 'Instruments');
        pdf.text(125, a, 'Dr Amount');
        pdf.text(140, a, 'Cr Amount');
        pdf.text(155, a, 'Total Amount');
        pdf.text(172, a, 'DR/CR');

        pdf.setTextColor(100); 
      }
      i++;
      a = a + b+4;
      c = c + 5+4;
      pdf.line(2, a - 7, e, a - 7);

      if ((i - 1) % f === 0) {
        pdf.setFontType("bolditalic");
        pdf.setTextColor(0, 0, 255);

        pdf.text(2, a, 'SR. No.');
        pdf.text(10, a, 'Date');
        pdf.text(40, a, 'Particulars');
       pdf.text(110, a, 'Instruments');
        pdf.text(125, a, 'Dr Amount');
        pdf.text(140, a, 'Cr Amount');
        pdf.text(155, a, 'Total Amount');
        pdf.text(172, a, 'DR/CR');

        pdf.setTextColor(100);
        a = a + b+4;
        c = c + 5+4;
        i++;
        pdf.line(2, a - 7, e, a - 7);
        this.indNum=Number(key)+1 ;
        pdf.text(5, a, (this.indNum)+'');
        pdf.text(10, a, value.postDate);
        if(value.particulars.length>52){
          //this.hasExtraLine=true;
          pdf.text(40, a-3, value.particulars.substring(0,52));
          pdf.text(40, a+1, value.particulars.substring(52,104));
        }else{
          pdf.text(40, a, value.particulars);
        }
      //  pdf.text(40, a, value.particulars.substring(0,71));
       pdf.text(110, a, value.instrNo);
        if (value.drCr === 'D') {
          pdf.text(125, a, value.fcyTrnAmt);
          pdf.text(172, a, 'DR');
          totalDrAmount = totalDrAmount + Number(value.fcyTrnAmt || 0);
          crDr = 'DR';
        }
        if (value.drCr === 'C') {
          pdf.text(140, a-2, value.fcyTrnAmt);
          pdf.text(172, a+1, 'CR');
          totalCrAmount = totalCrAmount + Number(value.fcyTrnAmt || 0);
          crDr = 'CR';
        }
        pdf.text(155, a, value.balance);

      } else {
         this.indNum =Number(key)+1;
        pdf.text(5, a, (this.indNum) + '');
        pdf.text(10, a, value.postDate);
        if(value.particulars.length>52){
          //this.hasExtraLine=true;
          pdf.text(40, a-3, value.particulars.substring(0,52));
          pdf.text(40, a+1, value.particulars.substring(52,104));
        }else{
          pdf.text(40, a, value.particulars);
        }
       // pdf.text(40, a, value.particulars.substring(0,71));
       pdf.text(110, a, value.instrNo);
        if (value.drCr === 'D') {
          pdf.text(125, a, value.fcyTrnAmt);
          pdf.text(172, a, 'DR');
          totalDrAmount = totalDrAmount + Number(value.fcyTrnAmt || 0);
          crDr = 'DR';
        }
        if (value.drCr === 'C') {
          pdf.text(140, a, value.fcyTrnAmt);
          pdf.text(172, a, 'CR');
          totalCrAmount = totalCrAmount + Number(value.fcyTrnAmt || 0);
          crDr = 'CR';
        }
        pdf.text(155, a, value.balance);
      }
      totalClosingAmount = value.balance;
      if (i % f === 0) {
        pdf.line(2, d - 3, 2, c - 3);
        pdf.line(9, d - 3, 9, c - 3);
        pdf.line(39, d - 3, 39, c - 3);
        pdf.line(109, d - 3, 109, c - 3);
        pdf.line(124, d - 3, 124, c - 3);
        pdf.line(139, d - 3, 139, c - 3);
        pdf.line(154, d - 3, 154, c - 3);
        pdf.line(179, d - 3, 179, c - 3);

        pdf.line(2, a + 2, e, a + 2);

        pdf.addPage();
        a = 20;
        d = 25;
        c = 25;
      }
    }

    pdf.line(2, d - 3, 2, c + 7);
    pdf.line(9, d - 3, 9, c - 3);
    pdf.line(39, d - 3, 39, c - 3);
    pdf.line(109, d - 3, 109, c - 3);
    pdf.line(124, d - 3, 124, c + 2);
    pdf.line(139, d - 3, 139, c + 2);
    pdf.line(154, d - 3, 154, c + 2);
    pdf.line(179, d - 3, 179, c + 7);

   // pdf.line(2, a - 3, e, a - 3);

    a = a + b;
    pdf.text(2, a, 'Totals / Balance :-');
   // console.log('totalDrAmount' +totalDrAmount+'totalCrAmount'+totalCrAmount+'totalClosingAmount'+totalClosingAmount);
    // pdf.text(125, a, totalDrAmount.toFixed() + '');
    // pdf.text(140, a, totalCrAmount.toFixed() + '');
  //   let lineCrossingNumb=123456789012.12123;
  //  let amtsorted = ((lineCrossingNumb.toFixed(2).toString().length>13) ? lineCrossingNumb.toFixed(0) : lineCrossingNumb.toFixed(2))+'';

  //  let totalDrLocal:number=Number(totalDrAmount.toFixed(2));
  //  let totlaDrsorted = ((totalDrLocal.toString().length>13) ? totalDrLocal.toFixed(0) : totalDrLocal.toFixed(2));
  //    let totalCrLocal=totalCrAmount;
  //   let totalCrSorted = ((totalCrLocal.toFixed(2).toString().length>13) ? totalCrLocal.toFixed(0) : totalCrLocal.toFixed(2))+'';

    //console.log('condition check  : '+amtsorted);

    // pdf.text(125, a, totalDrAmount.toFixed(2) + '');
    // pdf.text(140, a, totalCrAmount.toFixed(2) + '');   
    
    pdf.text(125, a, ((totalDrAmount.toFixed(2).toString().length>13) ? totalDrAmount.toFixed(0) : totalDrAmount.toFixed(2)));
    pdf.text(140, a, ((totalCrAmount.toFixed(2).toString().length>13) ? totalCrAmount.toFixed(0) : totalCrAmount.toFixed(2)));
    pdf.text(155, a, totalClosingAmount + '');
    pdf.text(172, a, crDr);

    pdf.line(2, a - 3, e, a - 3);

    a = a + b;
    // pdf.text(2, a, 'Closing Balance As On 29/11/2016 :-');
    pdf.text(2, a, 'Closing Balance :-');
    pdf.text(155, a, totalClosingAmount + '');
    pdf.line(2, a - 3, e, a - 3);

    a = a + b;
    pdf.line(2, a - 3, e, a - 3);

    var accShort = "XXXXXXXXXXX"+ this.statacct.substring(11) ;
    var img = new Image;
    img.onload = function() {
      pdf.setPage(1);
      pdf.addImage(this, 2, 0, 100, 17);
     
      pdf.save("Statment "+accShort + ".pdf");
    };
    img.src = 'assets/img/LogoWithName.png';
  }

  downloadcsv() {
    var csvData = this.ConvertToCSV(this.data);
    var a = document.createElement("a");
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    var blob = new Blob([csvData], {type: 'text/csv'});
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = 'Statment.csv';
    a.click();
  }
  ConvertToCSV(objArray) {
    var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0]) {
      //Now convert each value to string and comma-separated
      row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
      var line = '';
      for (var index in array[i]) {
        if (line !== '') { line += ',';}

        line += array[i][index];
      }
      str += line + '\r\n';
    }
    return str;
  }

  // setData(year, month, day) {
  // let date = moment().set({'year': year, 'month': month, 'day': day});
  //return date.format('L')  // 01/24/2018
  //}

  getMonthName(month) {
    return ["Jan", "Feb", "Mar", "Apr", "May", "June", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][Number(month) - 1];
  }

  removestacctMessage()
  {
    this.accountNull='';
  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/statment-of-account/statment-of-account.component.ts